<template>
  <div
    :id="id"
    class="modal-update-table">
    <div class="modal-update-table-wrap">
      <img src="@/assets/logo/icon-table.svg">
      <p class="modal-update-table-title">
        Are you sure to <span>Update this Table</span> ?
      </p>
      <p class="modal-update-table-subtitle">{{ tableName }}</p>
      <div class="modal-update-table-button">
        <b-button
          class="btn-blue"
          @click="$emit('submit')">
          Yes
        </b-button>
        <b-button @click="$emit('close')">Cancel</b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
      required: true,
    },
    tableName: {
      type: String,
      default: '',
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/data-manager/jModalUpdateTable.vue